import React, { useEffect } from "react";

import { useHistory, useLocation, Route } from "react-router-dom";

import { LOGIN_URL } from "@/core/urls";

import { useAuthContext } from "./AuthProvider";
import Loading from "./Loading";

function AuthRoute({ renderLoadingTemplate, loginUrl, ...props }) {
  const history = useHistory();
  const location = useLocation();
  const { user } = useAuthContext();

  // Redirect to login page if the user is loaded but is in fact null
  useEffect(() => {
    if (!user) {
      const next = encodeURIComponent(`${location.pathname}${location.search}`);
      history.push(`${loginUrl || LOGIN_URL}?next=${next}`);
    }
    // eslint-disable-next-line
  }, [user, loginUrl, location.pathname, location.search]);

  // If we are waiting for the redirect to kick in, render a loading
  // component instead of the actual route
  if (!user) {
    return renderLoadingTemplate ? renderLoadingTemplate(<Loading />) : <Loading />;
  }

  return <Route {...props} />;
}

export default AuthRoute;
